import { CommonModule }           from '@angular/common';
import { NgModule }               from '@angular/core';
import { ActionItemModule }       from '@shared/components/action-item/action-item.module';
import { FileDropTableComponent } from '@shared/components/file-drop/file-drop-table/file-drop-table.component';
import { DirectivesModule }       from '@shared/directives/directives.module';


@NgModule( {
	declarations: [
		FileDropTableComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared
		ActionItemModule,
		DirectivesModule
	],
	exports: [
		FileDropTableComponent
	]
} )
export class FileDropTableModule {}
